"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React, { useState } from "react";
import { FolderComponent } from "../FolderTree/FolderComponent/FolderComponent";
import { Folder, ChevronRight, Add, ChevronLeft, Tick } from "../../icons";
import OnClickOutside from "../../../utils/OnClickOutside";
import classNames from "classnames";
import TextInput, { TextInputSize } from "../TextInput/TextInput";
import { Alert, AlertType } from "../Alert";
import Button, { ButtonType, ButtonSize } from "../Button/Button";
import Tooltip from "../Tooltip/Tooltip";
import { Text } from "../Text";
import { KeyType } from "../../../utils";
var RemoteDataStatus = /* @__PURE__ */ ((RemoteDataStatus2) => {
  RemoteDataStatus2["NotRequested"] = "notRequested";
  RemoteDataStatus2["Loading"] = "loading";
  RemoteDataStatus2["Success"] = "success";
  RemoteDataStatus2["Error"] = "error";
  return RemoteDataStatus2;
})(RemoteDataStatus || {});
export const FolderDropdown = (props) => {
  const [currentFolderId, setCurrentFolderId] = useState(props.initialFolderId ? props.initialFolderId : "");
  const [showAddFolder, setAddFolder] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const folders = props.folders.status == "success" /* Success */ ? props.folders.data : [];
  const rootFolder = { id: "", name: props.rootFolderName };
  const folderLookup = folders.find((folder) => folder.id == currentFolderId);
  const currentFolder = folderLookup ? folderLookup : rootFolder;
  const children = folders.filter((folder) => folder.parent == currentFolderId);
  const onClickOutside = new OnClickOutside([".new-folder-form"], () => {
    toggleAddFolderInput(false);
  });
  const onClickOutsideError = new OnClickOutside([".folder-dropdown__error"], () => {
    setErrorMessage("");
  });
  const toggleAddFolderInput = (isOpen) => {
    setAddFolder(isOpen);
    if (isOpen)
      onClickOutside.startListening();
    else
      onClickOutside.stopListening();
  };
  const toggleErrorMessage = (error) => {
    setErrorMessage(error);
    if (error)
      onClickOutsideError.startListening();
    else
      onClickOutsideError.stopListening();
  };
  const createFolder = () => __async(void 0, null, function* () {
    try {
      const id = yield props.onAddFolder(newFolderName, currentFolderId ? currentFolderId : void 0);
      setCurrentFolderId(id);
    } catch (error) {
      toggleErrorMessage("Unable to create folder.");
    }
    toggleAddFolderInput(false);
    return false;
  });
  const moveUpFolder = (folder) => {
    setCurrentFolderId(folder.parent ? folder.parent : rootFolder.id);
  };
  const addFolderForm = /* @__PURE__ */ React.createElement("div", { className: "new-folder-form" }, /* @__PURE__ */ React.createElement(
    FolderComponent,
    {
      name: "New Folder Placeholder",
      icon: /* @__PURE__ */ React.createElement(Folder, null),
      selected: false,
      overrideNameComponent: /* @__PURE__ */ React.createElement("span", { className: "new-folder-wrapper" }, /* @__PURE__ */ React.createElement(
        TextInput,
        {
          label: "New Folder Name",
          labelHidden: true,
          placeholder: "Type Something",
          className: "folder-dropdown__form--input",
          size: TextInputSize.Small,
          onChange: (folderName) => setNewFolderName(folderName),
          onKeyDown: (e) => {
            if (e.key === KeyType.Enter)
              createFolder();
            if (e.key === KeyType.Escape)
              toggleAddFolderInput(false);
          },
          autoFocus: true
        }
      ), /* @__PURE__ */ React.createElement(
        Button,
        {
          type: ButtonType.Secondary,
          size: ButtonSize.Small,
          onClick: () => {
            createFolder();
          }
        },
        /* @__PURE__ */ React.createElement(Tick, null)
      ))
    }
  ));
  return /* @__PURE__ */ React.createElement("div", { className: classNames("folder-dropdown", { "parent-selected": currentFolder.id == "" }) }, /* @__PURE__ */ React.createElement(
    FolderComponent,
    {
      name: currentFolder.name,
      icon: currentFolder.id != "" ? /* @__PURE__ */ React.createElement(ChevronLeft, { opacity: 50 }) : /* @__PURE__ */ React.createElement(React.Fragment, null),
      onClick: () => moveUpFolder(currentFolder),
      selected: false
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "folder-dropdown__children" }, props.folders.status == "success" /* Success */ ? children.length > 0 ? children.map((folder, i) => {
    return /* @__PURE__ */ React.createElement(
      FolderComponent,
      {
        key: i,
        name: "",
        icon: /* @__PURE__ */ React.createElement(Folder, null),
        onClick: () => setCurrentFolderId(folder.id),
        selected: false,
        overrideNameComponent: /* @__PURE__ */ React.createElement("span", { className: "folder-dropdown__folder" }, /* @__PURE__ */ React.createElement("span", { className: "folder-dropdown__children--name" }, folder.name), folders.filter((item) => item.parent == folder.id).length ? /* @__PURE__ */ React.createElement(ChevronRight, null) : /* @__PURE__ */ React.createElement(React.Fragment, null))
      }
    );
  }) : !showAddFolder ? /* @__PURE__ */ React.createElement(Text, { size: "s" }, "No folders here") : "" : "Loading", showAddFolder && addFolderForm), /* @__PURE__ */ React.createElement("div", { className: "folder-dropdown__controls" }, /* @__PURE__ */ React.createElement(Tooltip, { content: "New Folder" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "folder-dropdown__controls--new",
      onClick: () => toggleAddFolderInput(!showAddFolder),
      type: ButtonType.Secondary
    },
    /* @__PURE__ */ React.createElement(Folder, { className: "folder-dropdown__controls--new__folder-icon" }),
    /* @__PURE__ */ React.createElement(Add, { className: "folder-dropdown__controls--new__add-icon" })
  )), /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "folder-dropdown__controls--select",
      size: ButtonSize.Small,
      type: ButtonType.Primary,
      onClick: () => props.onSelect(currentFolderId)
    },
    "Select Folder"
  )), errorMessage && /* @__PURE__ */ React.createElement(Alert, { className: "folder-dropdown__error", heading: "Error", alertType: AlertType.Error }, errorMessage));
};
